import * as actionType from "../Actions/Action_Type";
import * as ROLES from "../Utils/Roles_Types.js";

const initialState = {
    isFetching        : false,
    errorMessage      : null,
    isAuthenticated   : true,
    templateList      : []
};

const stampeReducer = (state = initialState, action) => {
    switch (action.type){
        //LISTA TEMPLATE
        case actionType.SERVICE_STAMPE_LIST_REQUEST :
            return Object.assign({}, state, {
                isFetching : true
            })
        case actionType.SERVICE_STAMPE_LIST_SUCCESS :
            return Object.assign({}, state, {
                isFetching    : false,
                authenticated : action.authenticated || false,
                templateList  : action.response
            })
        case actionType.SERVICE_STAMPE_LIST_ERROR :
            return Object.assign({}, state, {
                isFetching   : false,
                errorMessage : action.error || null
            })
        //AGGIORNA SINGOLO TEMPLATE
        case actionType.SERVICE_STAMPE_CHANGE_FAVORITE :
            action.list[action.index].Preferita = !action.list[action.index].Preferita;
            return Object.assign({}, state, {
                isFetching  : false,
                templateList : action.list
            })
        //SETTA PREFERITA
        case actionType.SERVICE_STAMPE_SET_FAVORITE_REQUEST :
            return Object.assign({}, state, {
                isFetching : true
            })
        case actionType.SERVICE_STAMPE_SET_FAVORITE_SUCCESS :
            var list = state.templateList;
            for( var tmp in list ){
                if( list[tmp].ID === action.response.ID )
                    list[tmp].Preferita = !list[tmp].Preferita;
            }
            return Object.assign({}, state, {
                isFetching    : false,
                authenticated : action.authenticated || false,
                templateList  : list
            })
        case actionType.SERVICE_STAMPE_SET_FAVORITE_ERROR :
            return Object.assign({}, state, {
                isFetching   : false,
                errorMessage : action.error || null
            })
        //SEETTA PREDEFINITA
        case actionType.SERVICE_STAMPE_SET_PREDEFINITE_REQUEST :
            return Object.assign({}, state, {
                isFetching : true
            })
        case actionType.SERVICE_STAMPE_SET_PREDEFINITE_SUCCESS :
            var list = state.templateList;
            for( var tmp in list ){
                if(list[tmp].ID !== action.response.ID)
                    list[tmp].Predefinita = false;
                else
                    list[tmp].Predefinita = !list[tmp].Predefinita;
            }
            
            return Object.assign({}, state, {
                isFetching    : false,
                authenticated : action.authenticated || false,
                templateList  : list
            })
        case actionType.SERVICE_STAMPE_SET_PREDEFINITE_ERROR :
            return Object.assign({}, state, {
                isFetching   : false,
                errorMessage : action.error || null
            })
        //RECUPERO I DATI DELL'UTENTE
        case actionType.SERVICE_USERINFO_REQUEST :
        return Object.assign({}, state, {
            isFetching : true,
        })
        case actionType.SERVICE_USERINFO_SUCCESS :
        var response = action.response;
        //salvo i dati dell'utente
        if(response.hasOwnProperty("IDUser") && response.hasOwnProperty("Username") && response.hasOwnProperty("Role")){
            localStorage.setItem(ROLES.USERINFO_KEY, JSON.stringify(response));
            return Object.assign({}, state, {
            isFetching      : false,
            isAuthenticated : action.authenticated || false,
            userInfo        : response
            })
        }else{
            return Object.assign({}, state, {
            isFetching      : false,
            isAuthenticated : false,
            userInfo        : null
            })
        }
        case actionType.SERVICE_USERINFO_ERROR :
        return Object.assign({}, state, {
            isFetching: false,
            errorMessage: action.error || null,
            isAuthenticated: false
        });
        default:
            return state;
    }
};

export default stampeReducer;


// WEBPACK FOOTER //
// ./src/Reducers/Reducer_Stampe.js